import { useMemo } from 'react';
import aiMusicGeneratorApi from 'services/api/aiMusicGenerator';
import type { IGenre } from 'services/api/entities';

const useGenre = (
  genreName: IGenre['name'] | null,
  microGenreName?: IGenre['name'] | null
) => {
  const { data: genres = [] } =
    aiMusicGeneratorApi.useGetAiMusicGeneratorGenresQuery();
  const genre = useMemo(() => {
    const genreData =
      genres.find(({ name, microGenres }) => {
        if (name === genreName) {
          return true;
        }
        return microGenres.find((microgenre) => genreName === microgenre.name);
      }) ?? null;

    if (!microGenreName) {
      return genreData;
    }

    return (
      genreData?.microGenres.find(({ name }) => name === microGenreName) ?? null
    );
  }, [genreName, microGenreName, genres]);

  return genre;
};

export default useGenre;
